import { Navigate, Outlet, useLocation } from "react-router-dom";

const POST_LOGIN_REDIRECT_KEY = "postLoginRedirect";
const AUTH_PATHS = /^\/(Login|Registration|ForgotPassword|ResetPassword|PetInformation|GetStarted)\b/i;

const ProtectedRoute = () => {
  const token = localStorage.getItem("Token");
  const location = useLocation();

  if (!token) {
    // Remember where the user was trying to go so Login can route them back after auth.
    // Skip auth pages so we don't bounce in a loop.
    if (!AUTH_PATHS.test(location.pathname)) {
      sessionStorage.setItem(
        POST_LOGIN_REDIRECT_KEY,
        location.pathname + location.search
      );
      // If they came in via a QR /r/:slug deep link, they explicitly chose
      // "Continue on Web" — don't show the "Open in App" popup on the Login
      // screen we're about to send them to.
      if (location.pathname.startsWith("/r/")) {
        sessionStorage.setItem("MOBILE_APP_POPUP_DISMISSED", "1");
      }
    }
    return <Navigate to="/Login" replace />;
  }
  return <Outlet />;
};

export default ProtectedRoute;
